<div class="loading"><div class="loading-frame"><div class="loading-image"><img :src="src" :alt="alt"></div></div></div>